<template>
    <vx-card :title='$t("PlannedAbsence")' collapse-action>
        <div class="mt-6">

            <absence-request-adding :header-text="false" v-if="$checkPermission(408)" class="mb-6" :base-u-r-l="'/api/v1/user/' + this.userId" @updateAbsence="updateAbsences()" @updateSickLeaves="updateAbsences()" @updateParentalLeaves="updateAbsences()" @updateVacations="updateAbsences()"></absence-request-adding>
            <vs-table :data="fullAbsenceList">
                <template slot="thead">
                    <vs-th>{{$t("StartTime")}}</vs-th>
                    <vs-th>{{$t("EndTime")}}</vs-th>
                    <vs-th>{{$t("Comments")}}</vs-th>
                    <vs-th>{{$t("Type")}}</vs-th>
                    <vs-th></vs-th>
                    <vs-th v-if="$checkPermission(406)"></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].start">
                            {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                        </vs-td>
                        <vs-td :data="data[indextr].end">
                            {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                        </vs-td>

                        <vs-td :data="data[indextr].notes">
                            {{data[indextr].notes}}
                        </vs-td>

                        <vs-td :data="data[indextr].type">
                            {{absenceTypeToText(data[indextr].type)}}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip v-if="data[indextr].status === 0" color="primary">{{$t("Waiting")}}</vs-chip>
                            <vs-chip v-else-if="data[indextr].status === 1" color="success">{{$t("Confirmed")}}</vs-chip>
                            <vs-chip v-else-if="data[indextr].status === 2" color="danger">{{$t("Rejected")}}</vs-chip>
                        </vs-td>
                        <vs-td v-if="$checkPermission(406)">
                            <vs-button v-if="data[indextr].status === 0 || data[indextr].status === 2" style="float: left" color="success" icon-pack="feather" icon="icon-check" type="border" class="mr-3" @click="approveAbsence(data[indextr].type, data[indextr].id)"></vs-button>
                            <vs-button v-if="data[indextr].status === 0 || data[indextr].status === 1" style="float: left" color="danger" icon-pack="feather" icon="icon-x" type="border" @click="openDenyAbsencePrompt(data[indextr].type, data[indextr].id)"></vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :title="$t('Reason')" :active.sync="denialNotesPrompt">
            <vs-textarea v-model="denialReason" class="w-full" />
            <vs-divider/>
            <vs-button :disabled="denialReason.length === 0" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="denyAbsence">{{$t("Save")}}</vs-button>
        </vs-popup>
    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import AbsenceRequestAdding from "./AbsenceRequestAdding";

    export default {
        components: {
            flatPickr,
            AbsenceRequestAdding
        },
        props: {
            userId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {

                absences: [],
                vacations: [],
                sick_leaves: [],
                parental_leaves: [],

                denialNotesPrompt: false,

                denialReason: '',
                selectedAbsenceId: 0,
                selectedAbsenceType: '',

            }
        },
        methods: {
            updateAbsences() {
                const thisIns = this;
                this.$http.get('/api/v1/user/' + this.userId + '/absence')
                    .then(function (response) {
                        thisIns.absences = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/user/' + this.userId + '/vacation')
                    .then(function (response) {
                        thisIns.vacations = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/user/' + this.userId + '/sick_leave')
                    .then(function (response) {
                        thisIns.sick_leaves = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/user/' + this.userId + '/parental_leave')
                    .then(function (response) {
                        thisIns.parental_leaves = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            approveAbsence(type, id){

                const thisIns = this;
                this.$http.put('/api/v1/user/' + this.userId + "/" + this.absenceTypeToURL(type) + '/' + id + "/status/1").then(function () {
                    thisIns.updateAbsences();
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            denyAbsence(){
                const thisIns = this;
                this.$http.put('/api/v1/user/' + this.userId + "/" + this.absenceTypeToURL(this.selectedAbsenceType) + '/' + this.selectedAbsenceId + "/status/2", {reason: this.denialReason}).then(function () {
                    thisIns.updateAbsences();
                    thisIns.denialNotesPrompt = false;
                }).catch(function (error) {
                    thisIns.denialNotesPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            openDenyAbsencePrompt(type, id) {
              this.selectedAbsenceId = id;
              this.selectedAbsenceType = type;
              this.denialNotesPrompt = true;
            },
            absenceTypeToURL(type){
              switch (type) {
                  case 0: return "absence";
                  case 1: return "vacation";
                  case 2: return "sick_leave";
                  case 3: return "parental_leave";
                  default: return "error";
              }
            },
            absenceTypeToText(type){
                switch (type) {
                    case 0: return this.$t("PlannedAbsence");
                    case 1: return this.$t("Vacation");
                    case 2: return this.$t("SickLeave");
                    case 3: return this.$t("ParentalLeave");
                    default: return "error";
                }
            }
        },
        computed: {
            fullAbsenceList: function () {
                let totalList = [];

                for(let x = 0; x < this.absences.length; x++){
                    totalList.push(
                        {
                            type: 0,
                            id: this.absences[x].id,
                            start: this.absences[x].start,
                            end: this.absences[x].end,
                            status: this.absences[x].status,
                            notes: this.absences[x].notes,
                        });
                }

                for(let x = 0; x < this.vacations.length; x++){
                    totalList.push(
                        {
                            type: 1,
                            id: this.vacations[x].id,
                            start: this.vacations[x].start,
                            end: this.vacations[x].end,
                            status: this.vacations[x].status,
                            notes: this.vacations[x].notes,
                        });
                }

                for(let x = 0; x < this.sick_leaves.length; x++){
                    totalList.push(
                        {
                            type: 2,
                            id: this.sick_leaves[x].id,
                            start: this.sick_leaves[x].start,
                            end: this.sick_leaves[x].end,
                            status: this.sick_leaves[x].status,
                            notes: this.sick_leaves[x].notes,
                        });
                }

                for(let x = 0; x < this.parental_leaves.length; x++){
                    totalList.push(
                        {
                            type: 3,
                            id: this.parental_leaves[x].id,
                            start: this.parental_leaves[x].start,
                            end: this.parental_leaves[x].end,
                            status: this.parental_leaves[x].status,
                            notes: this.parental_leaves[x].notes,
                        });
                }

                totalList.sort((a, b) => (a.start > b.start) ? 1 : -1);

                return totalList;
            }
        },
        created() {
            this.updateAbsences();
        }
    }

</script>
